// #======================================#
// #     _____       _ _       _  _       #
// #    |  __ \     (_) |     | || |      #
// #    | |__) |__ _ _| |___  | || |_     #
// #    |  _  // _` | | / __| |__   _|    #
// #    | | \ \ (_| | | \__ \    | |      #
// #    |_|  \_\__,_|_|_|___/    |_|      #
// #                                      #
// #======================================#

(function($) {
  'use strict';

  // forced_open is deprecated!
  $.extend({
    cwDropmenus: {
      menus: null,
      init: function() {
        var delay_close = 300;
        var delay_open = 300;
        $('html').addClass('dropmenus-active');
        $.cwDropmenus.menus = $('.cw_dropmenu, .cw-droptip');
        $.cwDropmenus.menus.each(function(){
          var $parent = $(this);
          // keyboard accesibility (tab through links)
          $parent.find('a').attr('tabindex', 1).on('focus', function(event){
            $.cwDropmenus.openMenu($parent);
          }).on('blur', function(event){
            $.cwDropmenus.closeMenu($parent, 0, true);
          });
          // touch
          $parent.on('touchstart', function(event){
            event.stopPropagation();
          });
          $parent.find('.cw_dropmenu_trigger').on('touchstart', function(event){
            event.preventDefault(); // prevent focus!
            if ($parent.hasClass('open')) {
              $.cwDropmenus.closeMenu($parent);
            } else {
              $.cwDropmenus.openMenu($parent);
            }
          });
          // mouse
          $parent.on('mouseenter', function(event){
            $.cwDropmenus.openMenu($parent, delay_open);
          });
          $parent.on('mouseleave', function(event){
            $.cwDropmenus.closeMenu($parent, delay_close, true);
          });
        });
      },
      closeAll: function() {
        $(document).off('touchstart.cw_dropdown');
        $.cwDropmenus.menus.each(function(){
          clearTimeout($(this).timer_open);
          clearTimeout($(this).timer_close);
          $(this).removeClass('open force-open');
        });
      },
      openMenu: function($el, delay) {
        if ($el.hasClass('forced_open') || $el.hasClass('force-open')) {
          return false;
        }
        delay = delay || 0;
        clearTimeout($el.timer_open);
        clearTimeout($el.timer_close);
        if (!$el.hasClass('open')) {
          $.cwDropmenus.closeAll();
        }
        $el.timer_open = setTimeout(function(){
          $el.addClass('open');
          $(document).on('touchstart.cw_dropdown', function(event) {
            $.cwDropmenus.closeAll();
          });
        }, delay);
      },
      closeMenu: function($el, delay, no_blur) {
        if ($el.hasClass('forced_open')) {
          return false;
        }
        delay = delay || 0;
        no_blur = no_blur || false;
        $(document).off('touchstart.cw_dropdown');
        clearTimeout($el.timer_open);
        clearTimeout($el.timer_close);
        $el.timer_close = setTimeout(function(){
          $el.removeClass('open');
          if (delay == 0) {
            $el.removeClass('force-open');
          }
          if (!no_blur) {
            $el.find('.cw_dropmenu_trigger').trigger('blur');
          }
        }, delay);
      }
    }
  });

  $(document).ready(function() {
    $.cwDropmenus.init();
  });

})(jQuery);
